import { ArrowPathIcon, CalendarDateRangeIcon, CheckCircleIcon, CloudArrowUpIcon, FingerPrintIcon, LockClosedIcon } from '@heroicons/react/24/outline'
import { Button } from '@mui/material'
import ContactModal from './ModalBeartungsTermin'
import BeratungsterminModal from '@/components/form/BeratungsterminModal'
import ButtonPrime from '@/components/navigation/ButtonPrime'

const features = [
  {
    name: 'Lokale Expertise',
    description:
      'Morbi viverra dui mi arcu sed. Tellus semper adipiscing suspendisse semper morbi. Odio urna massa nunc massa.',
    icon: CheckCircleIcon,
  },
  {
    name: 'Unterlagenbeschaffung und -aufbereitung',
    description:
      'Sit quis amet rutrum tellus ullamcorper ultricies libero dolor eget. Sem sodales gravida quam turpis enim lacus amet.',
    icon: CheckCircleIcon,
  },
  {
    name: 'Immobilienbewertung & Marktanalyse',
    description:
      'Quisque est vel vulputate cursus. Risus proin diam nunc commodo. Lobortis auctor congue commodo diam neque.',
    icon: CheckCircleIcon,
  },
  {
    name: 'Umfassendes Netzwerk',
    description:
      'Arcu egestas dolor vel iaculis in ipsum mauris. Tincidunt mattis aliquet hac quis. Id hac maecenas ac donec pharetra eget.',
    icon: CheckCircleIcon,
  },
  {
    name: 'Moderne Immobilienvermarktung',
    description:
      'Arcu egestas dolor vel iaculis in ipsum mauris. Tincidunt mattis aliquet hac quis. Id hac maecenas ac donec pharetra eget.',
    icon: CheckCircleIcon,
  },
  {
    name: 'Verhandlungsführung und Vertragsgestaltung',
    description:
      'Arcu egestas dolor vel iaculis in ipsum mauris. Tincidunt mattis aliquet hac quis. Id hac maecenas ac donec pharetra eget.',
    icon: CheckCircleIcon,
  },
  {
    name: 'Bonitätsprüfung des Käufers',
    description:
      'Arcu egestas dolor vel iaculis in ipsum mauris. Tincidunt mattis aliquet hac quis. Id hac maecenas ac donec pharetra eget.',
    icon: CheckCircleIcon,
  },
  {
    name: 'Service nach dem Verkauf',
    description:
      'Arcu egestas dolor vel iaculis in ipsum mauris. Tincidunt mattis aliquet hac quis. Id hac maecenas ac donec pharetra eget.',
    icon: CheckCircleIcon,
  },
]

export default function FeaturesSection() {
  return (
    <div className="bg-white py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <p className="mt-2 text-pretty  text-4xl font-semibold tracking-tight text-gray-800 sm:text-5xl lg:text-balance">
Rundum-Sorglos-Service für Verkäufer
          </p>
        </div>
        <div className="mx-auto mt-10 max-w-2xl flex flex-col justify-center sm:mt-12 lg:mt-6 lg:max-w-4xl">
          <dl className="grid  py-10 max-w-xl grid-cols-1 items-center justify-start lg:gap-x-8 gap-y-10 lg:max-w-none md:grid-cols-2 lg:gap-y-5">
            {features.map((feature) => (
              <div key={feature.name} className="relative lg:pl-16 rounded-md flex justify-start items-start gap-3">
                <dt className="text-base/7 font-semibold flex gap-3  text-gray-900">
                  
                    <feature.icon aria-hidden="true" className="size-6 text-white  stroke-green-400" />
                  
                  {feature.name}
                </dt>
              </div>
              
            ))}
          </dl>
            <BeratungsterminModal trigger={<ButtonPrime className="w-full mt-5" icon={<CalendarDateRangeIcon className='size-7' /> } text="Beratungstermin vereinbaren" />} />
        </div>
      </div>
    </div>
  )
}
